import React, { useRef, useEffect } from "react";
import { Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { globalTheme } from "../../../../styles";
import "./ShipmentsLogsTable.css";

interface ShipmentsLogsTableProps {
  rowData: IOrderShipmentLogs[];
  columnDefs: ColDef[];
}

export const ShipmentsLogsTable = ({ rowData, columnDefs }: ShipmentsLogsTableProps) => {
  const gridRef = useRef<any>(null);

  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setRowData(rowData);
    }
  }, [rowData]);

  return (
    <Paper elevation={4} sx={{ borderRadius: 8 }}>
      <div className={"ag-theme-alpine"} style={{ height: "80dvh", minHeight: 0 }}>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          rowSelection="multiple"
          suppressRowClickSelection={true}
          // onRowSelected={(e) => {
          //   console.log("Selected rows", gridRef.current.api.getSelectedRows());
          // }}
          overlayNoRowsTemplate={`<span aria-live="polite" aria-atomic="true" style="padding: 10px; background: ${globalTheme.background}; border-radius: 8px;">No data available</span>`}
          // onFilterChanged={(e) => console.log(e)}
        />
      </div>
    </Paper>
  );
};
